import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./DetailFilm.css";

export default function DetailFilm() {
  const { idFilm } = useParams();
  const navigate = useNavigate();
  const apiKey = "9b2511a35c2a1b656502230e8819a81c";
  const baseApiUrl = `https://api.themoviedb.org/3/movie/${idFilm}?api_key=${apiKey}&language=fr-FR`;

  const [film, setFilm] = useState(null);
  const [cast, setCast] = useState([]);
  const [trailer, setTrailer] = useState(null);
  const [director, setDirector] = useState("");
  const [writer, setWriter] = useState("");
  const [reviews, setReviews] = useState([]);
  const [recommendations, setRecommendations] = useState([]);

  useEffect(() => {
    fetch(baseApiUrl)
      .then((res) => res.json())
      .then(setFilm)
      .catch(console.error);

    fetch(`${baseApiUrl}&append_to_response=credits,videos,reviews,recommendations`)
      .then((res) => res.json())
      .then((data) => {
        setCast(data.credits.cast.slice(0, 10));
        setDirector(data.credits.crew.find((p) => p.job === "Director")?.name || "Inconnu");
        setWriter(data.credits.crew.find((p) => ["Screenplay", "Writer"].includes(p.job))?.name || "Inconnu");
        setTrailer(data.videos.results.find((v) => v.type === "Trailer" && v.site === "YouTube")?.key);
        setReviews(data.reviews.results.slice(0, 3));
        setRecommendations(data.recommendations.results);
      })
      .catch(console.error);
  }, [baseApiUrl]);

  if (!film) return <div className="film-detail-loading">Chargement...</div>;

  const year = film.release_date ? film.release_date.slice(0, 4) : "—";
  const runtime = film.runtime ? `${film.runtime} min` : "—";
  const rating = film.vote_average ? `${film.vote_average.toFixed(1)}/10` : "—";
  const backdrop = film.backdrop_path
    ? `https://image.tmdb.org/t/p/original/${film.backdrop_path}`
    : film.poster_path
    ? `https://image.tmdb.org/t/p/original/${film.poster_path}`
    : "";

  return (
    <div className="film-detail-page">
      <section
        className="detail-hero"
        style={{ backgroundImage: backdrop ? `url(${backdrop})` : "none" }}
      >
        <div className="detail-hero-overlay">
          <button className="detail-back" type="button" onClick={() => navigate(-1)}>
            ← Retour
          </button>
          <div className="detail-hero-content">
            {film.poster_path && (
              <img
                className="detail-poster"
                src={`https://image.tmdb.org/t/p/w500/${film.poster_path}`}
                alt={film.title}
              />
            )}
            <div className="detail-hero-text">
              <h1>{film.title}</h1>
              <div className="detail-meta">
                <span>{year}</span>
                <span>{runtime}</span>
                <span>{rating}</span>
              </div>
              <div className="detail-genres">
                {film.genres.map((genre) => (
                  <span key={genre.id}>{genre.name}</span>
                ))}
              </div>
              <p className="detail-tagline">{film.tagline || "Un film à découvrir maintenant."}</p>
              <div className="detail-actions">
                <button
                  className="detail-primary"
                  type="button"
                  onClick={() => trailer && navigate(`/lecteur/${idFilm}`)}
                  disabled={!trailer}
                >
                  Regarder le trailer
                </button>
                <button className="detail-secondary" type="button" onClick={() => navigate("/")}>
                  Explorer les films
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="detail-body">
        <div className="detail-overview">
          <h2>Synopsis</h2>
          <p>{film.overview || "Aucune description disponible."}</p>
          <div className="detail-credits">
            <div>
              <span>Réalisateur</span>
              <strong>{director}</strong>
            </div>
            <div>
              <span>Scénario</span>
              <strong>{writer}</strong>
            </div>
          </div>
        </div>

        <div className="detail-cast">
          <h3>Distribution</h3>
          <div className="actors-container">
            {cast.map((actor) => (
              <div key={actor.id} className="actor-card">
                <img
                  className="actor-photo"
                  src={
                    actor.profile_path
                      ? `https://image.tmdb.org/t/p/w200/${actor.profile_path}`
                      : "https://via.placeholder.com/80"
                  }
                  alt={actor.name}
                />
                <p className="actor-name">{actor.name}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="detail-reviews">
          <h3>Avis des spectateurs</h3>
          <div className="reviews-container">
            {reviews.length > 0 ? (
              reviews.map((review) => (
                <div key={review.id} className="review-card">
                  <p className="review-author">{review.author}</p>
                  <p>
                    {review.content.length > 200
                      ? `${review.content.substring(0, 200)}...`
                      : review.content}
                  </p>
                </div>
              ))
            ) : (
              <p className="review-empty">Aucun avis disponible.</p>
            )}
          </div>
        </div>

        <div className="detail-recommendations">
          <h3>Films similaires</h3>
          <div className="recommendations-container">
            {recommendations.length > 0 ? (
              recommendations.map((rec) => (
                <div
                  key={rec.id}
                  className="recommendation-card"
                  onClick={() => navigate(`/detail/${rec.id}`)}
                >
                  {rec.poster_path && (
                    <img
                      className="recommendation-poster"
                      src={`https://image.tmdb.org/t/p/w200/${rec.poster_path}`}
                      alt={rec.title}
                    />
                  )}
                  <p className="recommendation-title">{rec.title}</p>
                </div>
              ))
            ) : (
              <p className="recommendation-empty">Aucune recommandation disponible.</p>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
